export default __webpack_public_path__ + "static/media/startGameBackground.95bfeaaf.svg";